import React from 'react';
import styled from 'styled-components';
import { SelectionTitle } from '../../../Styles';

const Wrapper = styled.div`
  margin-top: 25px;
  padding: 0 25px;
  .assembly-container {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
  }
`;

function Assembly({ assemblyId, productData, setProductVar }) {
  const handleProductVar = assemblyId => {
    setProductVar({
      frame_id: productData.frame.id,
      //render property / value if the size is not null
      ...(productData.fabric && {
        fabric_id: productData.fabric.id
      }),
      ...(productData.frame.size !== null && {
        size_id: productData.frame.size.id
      }),
      ...(productData.frame.firmness && {
        firmness_id: productData.frame.firmness.id
      }),
      //render property / value if the leg is not null
      ...(productData.leg && {
        leg_id: productData.leg.id
      }),
      ...(productData.constructionType && {
        construction_type_id: productData.constructionType.id
      }),
      ...(productData.casterLeg && {
        caster_leg_id: productData.casterLeg.id
      }),
      ...(productData.frame.orientation !== null && {
        orientation: productData.frame.orientation
      }),
      ...(productData.frame.has_wallpaper_types && {
        wallpaper_type: productData.wallpaper_type
      }),
      is_assembled: assemblyId
    });
  };

  return (
    <Wrapper>
      <SelectionTitle>Assembly Preference</SelectionTitle>
      <div className="assembly-container">
        {assembledData.map(assembly => {
          return (
            <AssemblyButton
              key={assembly.id}
              selected={parseInt(assemblyId) === parseInt(assembly.id)}
              onClick={() => {
                handleProductVar(assembly.id);
              }}
            >
              {assembly.name}
            </AssemblyButton>
          );
        })}
      </div>
    </Wrapper>
  );
}

export default Assembly;

const AssemblyButton = styled.button`
  border: ${({ selected, theme }) =>
    selected ? `3px solid ${(theme.old ? '#2A5CAF' : theme.colors.french)}` : '1px solid black;'};
  height: 50px;
  width: 100%;
  background: white;
`;

const assembledData = [
  {
    id: 1,
    name: `Assembled`
  },
  {
    id: 0,
    name: `Requires Assembly`
  }
];
